import React from 'react';
import { Typography } from 'antd';
import { isNil, isEmpty, includes } from 'ramda';
import { generators, asserts } from '../../../utils';
import { TagCheck } from '../../biz';
import { useDidMount } from '../../use';
import { setSerachLog, searchEventType } from '../../../utils/addLog';

const emptyImg = `${process.env.TARGET}static/imgs/menu_empty.jpg`;

const { Text } = Typography;

export default ({
  scatId,
  subMenu = [],
  standardMenu,
  pushAway,
  material = [],
  onTabChange,
  type,
}) => {
  const [activeKey, setActiveKey] = React.useState('1'); //当前是在小类还是标准
  const [catMenu, setCateMenu] = React.useState([]);
  const [standMenu, setStandMenu] = React.useState({});
  const [materials, setMaterials] = React.useState([]);
  const [checkValue, setCheckValue] = React.useState(null); //当前选中的材质的值
  const [carouselReact, setCarouselReact] = React.useState('');

  useDidMount(() => {
    const isScale = window.tmConfig.isScale();
    const cls = isScale ? 'menu-content-media-width' : 'menu-content-media-width-standard';
    setCarouselReact(cls);
  });

  React.useEffect(() => {
    onTabChange && onTabChange(activeKey);
  }, [activeKey]); // eslint-disable-line
  React.useEffect(() => {
    onTabChange && onTabChange(checkValue);
  }, [checkValue]); // eslint-disable-line

  React.useEffect(() => {
    setMaterials(material);
    setCateMenu(subMenu);
    setStandMenu(standardMenu);
  }, [subMenu, standardMenu, material]);

  const selectedValue = React.useMemo(() => {
    if (isNil(checkValue)) return [];
    return [checkValue];
  }, [checkValue]);

  const handlePush = (path) => {
    pushAway(path);
  };

  const handleTagChange = (value) => {
    setCheckValue(value[0]);
  };

  const handleLeaveSubMenu = () => {
    setActiveKey('1');
    setCheckValue(null);
  };

  const CatCom = ({ menu }) => (
    <div className="content-row">
      <Text
        className="content-row-label"
        onClick={() => {
          setSerachLog(searchEventType.letfMenu, '');
          handlePush(`/search?scatId=${scatId}&pcatId=${menu.catId}`);
        }}
      >
        {menu.catName}
      </Text>
      <span className="content-row-content">
        {generators.generatorArray(menu.children).map((item, j) => {
          if (!checkValue) {
            return (
              <span className="sub-content-tag" key={item.catId}>
                <Text
                  onClick={() => {
                    setSerachLog(searchEventType.letfMenu, '');
                    handlePush(
                      `/search?scatId=${scatId}&pcatId=${item.pcatId}&catCode=${item.catCode}&catId=${item.catId}`,
                    );
                  }}
                >
                  <div>
                    <div
                      style={{ display: 'inline-block' }}
                      dangerouslySetInnerHTML={{ __html: item.catLabel }}
                    />
                    <span>{item.catName}</span>
                  </div>
                </Text>
                <div className="tag-img">
                  <div className="img-title">{item.itemName}</div>
                  <img
                    src={
                      asserts.isExist(item.icoSrc)
                        ? `${process.env.ASSETS}/${item.icoSrc}`
                        : emptyImg
                    }
                    alt={item.itemName}
                  />
                </div>
              </span>
            );
          } else {
            if (!item.itemMaterial) return null;
            const matStr = !!item.itemMaterial ? item.itemMaterial : '';
            const matArr = matStr.split(',');
            return includes(checkValue, matArr) ? (
              <span className="sub-content-tag" key={item.catId}>
                <Text
                  onClick={() => {
                    setSerachLog(searchEventType.letfMenu, '');
                    handlePush(
                      `/search?scatId=${scatId}&pcatId=${item.pcatId}&catCode=${item.catCode}&catId=${item.catId}`,
                    );
                  }}
                >
                  {/* {item.catName} */}
                  <div>
                    <div
                      style={{ display: 'inline-block' }}
                      dangerouslySetInnerHTML={{ __html: item.catLabel }}
                    />
                    <span>{item.catName}</span>
                  </div>
                </Text>
                <div className="tag-img">
                  <div className="img-title">{item.itemName}</div>
                  <img
                    src={
                      asserts.isExist(item.icoSrc)
                        ? `${process.env.ASSETS}/${item.icoSrc}`
                        : emptyImg
                    }
                    alt={item.itemName}
                  />
                </div>
              </span>
            ) : null;
          }
        })}
      </span>
    </div>
  );

  const StandardCom = ({ standard }) => (
    <div className="content-row">
      <Text
        className="content-row-label"
        onClick={() => {
          setSerachLog(searchEventType.letfMenu, '');
          handlePush(`/search?scatId=${scatId}&catType=${standard}`);
        }}
      >
        {standard}
      </Text>
      <span className="content-row-content">
        {generators.generatorArray(standMenu[standard]).map((item, j) => {
          if (!checkValue) {
            return (
              <span className="sub-content-tag" key={item.catId}>
                <Text
                  onClick={() => {
                    setSerachLog(searchEventType.letfMenu, '');
                    handlePush(
                      `/search?scatId=${scatId}&catType=${standard}&catCode=${item.catCode}`,
                    );
                  }}
                >
                  {/* {item.catName} */}
                  <div>
                    <div
                      style={{ display: 'inline-block' }}
                      dangerouslySetInnerHTML={{ __html: item.catLabel }}
                    />
                    <span>{item.catName}</span>
                  </div>
                </Text>
                <div className="tag-img">
                  <div className="img-title">{item.itemName}</div>
                  <img
                    src={
                      asserts.isExist(item.icoSrc)
                        ? `${process.env.ASSETS}/${item.icoSrc}`
                        : emptyImg
                    }
                    alt={item.itemName}
                  />
                </div>
              </span>
            );
          } else {
            if (!item.itemMaterial) return null;
            const matStr = !!item.itemMaterial ? item.itemMaterial : '';
            const matArr = matStr.split(',');
            return includes(checkValue, matArr) ? (
              <span className="sub-content-tag" key={item.catId}>
                <Text
                  onClick={() => {
                    setSerachLog(searchEventType.letfMenu, '');
                    handlePush(
                      `/search?scatId=${scatId}&catType=${standard}&catCode=${item.catCode}`,
                    );
                  }}
                >
                  {/* {item.catName} */}
                  <div>
                    <div
                      style={{ display: 'inline-block' }}
                      dangerouslySetInnerHTML={{ __html: item.catLabel }}
                    />
                    <span>{item.catName}</span>
                  </div>
                </Text>
                <div className="tag-img">
                  <div className="img-title">{item.itemName}</div>
                  <img
                    src={
                      asserts.isExist(item.icoSrc)
                        ? `${process.env.ASSETS}/${item.icoSrc}`
                        : emptyImg
                    }
                    alt={item.itemName}
                  />
                </div>
              </span>
            ) : null;
          }
        })}
      </span>
    </div>
  );
  // 如果是自定义菜单
  if (type === 'custom') {
    return (
      <div className={`category-menu-sub ${carouselReact}`} onMouseLeave={handleLeaveSubMenu}>
        {/* <nav className="sub-title-wrapper">
          <span
            className={`sub-title ${activeKey === '1' ? 'sub-title-active' : ''}`}
            onClick={() => setActiveKey('1')}
          >
            小类
          </span>
          <span
            className={`sub-title ${activeKey === '2' ? 'sub-title-active' : ''}`}
            onClick={() => setActiveKey('2')}
          >
            标准
          </span>
        </nav> */}
        <div className="sub-content-header">
          <TagCheck
            className="myTagCheck"
            dataSource={materials}
            value={selectedValue}
            onChange={handleTagChange}
          />
        </div>
        <div
          className="sub-content-wrapper"
          style={{ display: activeKey === '1' ? 'block' : 'none' }}
        >
          {catMenu.map((menu, i) => {
            const materials = !!menu.itemMaterial ? menu.itemMaterial : '';
            const mateArr = materials.split(',');
            if (!checkValue) {
              return <CatCom menu={menu} key={menu.catId} />;
            } else {
              if (!includes(checkValue, mateArr)) return null;
              return <CatCom menu={menu} key={menu.catId} />;
            }
          })}
        </div>
        <div
          className="sub-content-wrapper"
          style={{ display: activeKey === '2' ? 'block' : 'none' }}
        >
          {Object.keys(standMenu).map((key) => {
            const allMaterial = [];
            standMenu[key].forEach((item) => {
              if (!asserts.isExist(item.materialList)) return null;
              item.materialList.forEach(({ code }) => allMaterial.push(code));
            });

            if (!checkValue) {
              return <StandardCom standard={key} key={key} />;
            } else {
              if (!includes(checkValue, allMaterial)) return null;
              return <StandardCom standard={key} key={key} />;
            }
          })}
        </div>
      </div>
    );
  }
  if (isEmpty(subMenu && standMenu) || isNil(subMenu && standMenu))
    return <div className={`category-menu-sub ${carouselReact}`} />;

  return (
    <div className={`category-menu-sub ${carouselReact}`} onMouseLeave={handleLeaveSubMenu}>
      <nav className="sub-title-wrapper">
        <span
          className={`sub-title ${activeKey === '1' ? 'sub-title-active' : ''}`}
          onClick={() => setActiveKey('1')}
        >
          小类
        </span>
        <span
          className={`sub-title ${activeKey === '2' ? 'sub-title-active' : ''}`}
          onClick={() => setActiveKey('2')}
        >
          标准
        </span>
      </nav>
      <div className="sub-content-header">
        <TagCheck
          className="myTagCheck"
          dataSource={materials}
          value={selectedValue}
          onChange={handleTagChange}
        />
      </div>
      <div
        className="sub-content-wrapper"
        style={{ display: activeKey === '1' ? 'block' : 'none' }}
      >
        {catMenu.map((menu, i) => {
          const materials = !!menu.itemMaterial ? menu.itemMaterial : '';
          const mateArr = materials.split(',');
          if (!checkValue) {
            return <CatCom menu={menu} key={menu.catId} />;
          } else {
            if (!includes(checkValue, mateArr)) return null;
            return <CatCom menu={menu} key={menu.catId} />;
          }
        })}
      </div>
      <div
        className="sub-content-wrapper"
        style={{ display: activeKey === '2' ? 'block' : 'none' }}
      >
        {Object.keys(standMenu).map((key) => {
          const allMaterial = [];
          standMenu[key].forEach((item) => {
            if (!asserts.isExist(item.materialList)) return null;
            item.materialList.forEach(({ code }) => allMaterial.push(code));
          });

          if (!checkValue) {
            return <StandardCom standard={key} key={key} />;
          } else {
            if (!includes(checkValue, allMaterial)) return null;
            return <StandardCom standard={key} key={key} />;
          }
        })}
      </div>
    </div>
  );
};
